<div class="modal-header">
  <h4 class="modal-title">Add Scheduled Event View Column</h4>
  <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body">
  <div class="alert alert-danger" *ngIf="availableColumnTypes.length === 0">
    All available columns have already been selected.
  </div>

  <div class="form-group">
    <label for="column_type">Column Type</label>
    <select class="custom-select"
            id="column_type" name="column_type"
            [(ngModel)]="column.column_type">
      <option [ngValue]="null" disabled class="disabled">---</option>
      <option *ngFor="let availableColumnType of availableColumnTypes"
              [ngValue]="availableColumnType.columnType">
        {{ availableColumnType.name }}
      </option>
    </select>
  </div>

  <div class="form-group" *ngIf="column.column_type === ScheduledEventsColumnType.capitanProfileField">
    <label for="profile_field_name">Capitan Profile Field</label>
    <select class="custom-select"
            id="profile_field_name" name="profile_field_name"
            [(ngModel)]="column.profile_field_name">
      <option [ngValue]="undefined" disabled class="disabled">---</option>
      <option *ngFor="let availableFieldName of availableCapitanProfileFieldNames"
              [ngValue]="availableFieldName">
        {{ getThisCustomerFieldLabel(availableFieldName) }}
      </option>
    </select>
  </div>

  <div class="form-group" *ngIf="column.column_type === ScheduledEventsColumnType.customCustomerField">
    <label for="custom_field_name">Custom Customer Field</label>
    <select class="custom-select"
            id="custom_field_name" name="custom_field_name"
            [(ngModel)]="column.custom_field_name">
      <option [ngValue]="undefined" disabled class="disabled">---</option>
      <option *ngFor="let availableFieldName of availableCustomCustomerFieldNames"
              [ngValue]="availableFieldName">
        {{ availableFieldName }}
      </option>
    </select>
  </div>

  <div class="form-group" *ngIf="column.column_type === ScheduledEventsColumnType.attendeeQuestion">
    <label for="question_name">Attendee Question</label>
    <select class="custom-select"
            id="question_name" name="question_name"
            [(ngModel)]="column.question_name">
      <option [ngValue]="undefined" disabled class="disabled">---</option>
      <option *ngFor="let availableQuestionName of availableAttendeeQuestionNames"
              [ngValue]="availableQuestionName">
        {{ availableQuestionName }}
      </option>
    </select>
  </div>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-secondary"
          (click)="activeModal.close()">
    Cancel
  </button>
  <button class="btn btn-primary"
          [disabled]="!isValid()"
          [class.disabled]="!isValid()"
          (click)="save()">
    Save
  </button>
</div>
